import React from 'react';
import styles from './index.module.scss';
import { cn } from '../../../utils/styles';

function HomeLayout({ children, containerClassName }: React.PropsWithChildren & { containerClassName?: string }) {
  return (
    <div className={cn(['home w-screen h-screen', styles.parent])}>
      {/** Background image container: */}
      <div
        className={cn(
          'bg-image',
          'absolute inset-0 h-full',
          'bg-gradient-to-r from-sky-600 to-indigo-800', // if bg-home-image not found
          'bg-home-image bg-cover blur-3xl backdrop-filter',
          'scale-125', // if use scale then need to add 'overflow: hidden' to parent.
          'brightness-[.45]',
        )}
      />
      <div className={styles.overlay} />

      <div className={cn('content-container relative blur-none', containerClassName)}>{children}</div>
    </div>
  );
}

HomeLayout.defaultProps = {
  containerClassName: undefined,
};

export default HomeLayout;
